import { isEmpty } from 'lodash';
import moment from 'moment';

import envVar from '../../config/envVars';
import httpGet from '../httpClient/httpGet';
import authenticationUtils from '../../utils/authenticationUtils';

const getQueryParams = (
  academicYear: string,
  grade: string,
  division: string,
  asOnDate: string,
  page: number,
  perPage: number
): string => {
  let queryParams = '';
  const encodedAsOnDate = encodeURIComponent(
    `${moment(asOnDate).format('YYYY-MM-DD')} 23:59:59`
  );
  queryParams += `session=${
    !isEmpty(academicYear) && academicYear !== 'All' ? academicYear : ''
  }&`;
  queryParams += `grade=${!isEmpty(grade) && grade !== 'All' ? grade : ''}&`;
  queryParams += `division=${
    !isEmpty(division) && division !== 'All' ? division : ''
  }&`;
  queryParams += `asOnDate=${encodedAsOnDate}&`;
  queryParams += `page=${page}&perPage=${perPage}`;
  return queryParams;
};

const getPendingFeeReport = async (
  academicYear: string,
  grade: string,
  division: string,
  asOnDate: string,
  page: number,
  perPage: number
) => {
  const queryParams = getQueryParams(
    academicYear,
    grade,
    division,
    asOnDate,
    page,
    perPage
  );
  return httpGet(
    `${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/reports/pendingPayments?${queryParams}`,
    {
      headers: {
        Authorization: `Bearer ${authenticationUtils.getEasypayToken()}`
      }
    }
  );
};

export { getPendingFeeReport };
